export interface HydraInterface{
    '@context'?: string;
    '@id'?: string;
    '@type'?: string;
}

export class Hydra implements HydraInterface{
    '@context'?: string;
    '@id'?: string;
    '@type'?: string;

    constructor(options: {} = null) {
        if (options) {
            Object.assign(this, options);
        }
    }

    public beforeSaveHydraRelation(index: string[]) {
        const prepare = this;
        index.forEach(key => {
            const toParse = this[key];
            if (
                toParse !== undefined &&
                toParse != null &&
                Array.isArray(toParse)
            ) {
                prepare[key] = [];
                for (let i = 0; i < toParse.length; i++) {
                    prepare[key].push(toParse[i]['@id']);
                }
            } else {
                if (typeof toParse == 'object') {
                    prepare[key] = toParse['@id'];
                }
            }
        });
        return prepare;
    }

    public getUrl() {
        return this['@id'];
    }
}
